import React, { useState, useEffect } from "react";
import "../../assets/scss/styles.scss";
import { renderAllStars } from "../../utils/hooks/renderstars"
import location from "../../assets/img/pin.png";

export const ContractorCard = ({ contractor, setShowModal, setRequestedContractor, setOverlay, user }) => {
    const [ showCardDetailMobile, setShowCardDetailMobile ] = useState(0)
    const [servesArea, setServesArea] = useState(false)

    useEffect(()=>{
        const checkServesArea = () => {
            if (contractor.districts_served_value.includes(user.district))
            setServesArea(true)
        }

        if (user) {
            checkServesArea()
        } else {
            setServesArea(false)
        }
    }, [user])

    // remove the service tags with empty values
    const serviceFields = contractor.detailedTags || [
        contractor.ppn_primary_specialty,
        contractor.ppn_secondary_specialty,
        contractor.ppn_tertiary_specialty,
        contractor.ppn_quaternary_specialty
    ].filter((x) => !!x).map((specialty) => ({tag:specialty, isMatched: false}))

    // allow more/less button to be clicked without hiding card details on mobile
    const handleMobileCardDisplay = (e) => {
        if (window.innerWidth < 1000) {
            if (!e.target.classList.contains('fac-tag-more-less')){
                setShowCardDetailMobile(!showCardDetailMobile)
            }
        }
    }

    const showDialog = () => {
		const scrollY = document.documentElement.style.getPropertyValue('--scroll-y');
		const body = document.body;
		body.style.position = 'fixed';
		body.style.top = `-${scrollY}`;
		body.style.width = '100%';
		body.style.paddingRight = '15px';
	};

    // const membershipYear = (contractor.ppn_member_since).split('/')[2];

    return (
        <div className="contractor-card-container" key="{contractor.id}" onClick={(e) => handleMobileCardDisplay(e) }>
            <div className="contractor-row contractor-card-name">
                <h2 className="contractor-card-title">
                    {contractor.company_name}
                </h2>
            </div>

            <div className="contractor-row contractor-card-details">
                <div className="contractor-card-location">
                    <img src={location} alt="location icon" className="locations-icon icon" />
                    <p className="contractor-city">{contractor.address1_city},</p>
                    <p className="contractor-state">&nbsp;{contractor.address1_state}</p>
                </div>
                <div className="contractor-card-projects">
                    {servesArea === true &&
                        <ul className="vendorServesArea"><li>Vendor HQ is located outside of your location but will serve your region</li></ul>
                    }
                </div>
            </div>

            <div className={ showCardDetailMobile? "contractor-row contractor-card-tags-mobile" : "contractor-row contractor-card-tags"}>
                <div className="tags-container">
                    {serviceFields.map((service,i) => (
                        <span className={`fac-tag ${service.isMatched && 'fac-tag-primary'}`} key={`servicetag${i}`}>{service.tag}</span>
                    ))}
                </div>

                <div>
                    <button className="fac-btn fac-btn-primary fac-service-btn-request"
                        onClick={() => {
                        setOverlay(true)
                        setShowModal(true)
                        showDialog()
                        setRequestedContractor({
                            contractor: contractor,
                            renderAllStars: renderAllStars
                        })
                    }}> Request info</button>
                </div>
            </div>
        </div>
    )
}
